import King from './King';
import { KingController } from './kingController';

export default King;
export { KingController };